import { TFunction } from 'i18next';
import * as yup from 'yup';

type RescheduleDirectUi = {
  dayIndex?: number;
  timeIndex?: number;
};

export const getLocalizedSchema = (t: TFunction): yup.ObjectSchema<RescheduleDirectUi> =>
  yup
    .object()
    .shape({
      dayIndex: yup.number().required(t('form.validation.fieldIsRequired')),
      timeIndex: yup.number().required(t('form.validation.fieldIsRequired')),
    })
    .required();

export type FormData = yup.InferType<ReturnType<typeof getLocalizedSchema>>;
